let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("71MIp")).then(() => parcelRequire('e68Bq'));